import React from 'react';
import Moment from 'moment';

export const ApprovalRejectedStatus = ({ data, rfq }) => {
    return <div>
        <div className="flex flex-row flex-between">
            <span className="section-sub-header-color fBold fs-16">
                Rejected Status
            </span>
        </div>
        <div className="flex pv-20 border-bottom-light flex-between flex-middle" >
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    User
                </span>
            </div>
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5 pl-15">
                    Remarks
                </span>
            </div>
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    Date
                </span>
            </div>
        </div>
        {(data || []).map((status, index) => {
            return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                    <div className="flex flex-1 col-3">
                        <span className="section-sub-header-color  fs-14">
                            {status.approver_reject_name && ((rfq['approver_names'] || []).find(approver => approver.email ===  status.approver_reject_name) || {}).user_name || ''}
                        </span>
                    </div>
                    <div className="flex flex-1 col-3">
                        <span className="section-sub-header-color  fs-14">
                            {status.approver_reject_remarks || ''}
                        </span>
                    </div>
                    <div className="flex flex-1 col-3">
                        {status.approver_reject_time && Moment(status.approver_reject_time).format('DD MMM YYYY HH:mm')}
                    </div>
                </div>
            })
        }
    </div>
}